import "./navigation.css";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import touchNavigation from "../../../assets/touchNavigation.svg";

export const Navigation = () => {
    const [open, setOpen] = useState("");
    const history = useNavigate();
    const location = window.location.pathname.split("/remyjeuniaux")[1];
    const isNew = !localStorage.getItem("discovered");

    const discovered = (ev) => {
        ev.stopPropagation();
        setOpen("open");
        localStorage.setItem("discovered", true);
    }

    const linkClick = (ev) => {
        if (window.matchMedia("(min-width: 700px)").matches) return;
        ev.preventDefault();
        if (open === "open") {
            ev.stopPropagation();
            ev.nativeEvent.stopImmediatePropagation();
            setOpen("closing");
            setTimeout(() => history('/' + ev.target.id, { replace: true }), 300);
        } else {
            setOpen("open");
        }
    }
    const handleGlobalClick = (ev) => {
        const root = document.querySelector(".web")
        if (!ev.composedPath().includes(root)) {
            setOpen("");
        }
    }

    useEffect(() => {
        window.addEventListener("click", handleGlobalClick);
        return () => {
            window.removeEventListener("click", handleGlobalClick);
        }
    });

    return <>
        { isNew && <div className="inviteNavigation displayMobile" onClick={discovered}>
            <img height="30" alt="" src={touchNavigation}/>
        </div> }
        <div className={`web ${open} ${location === "/portfolio" ? "spawnPortfolio" : ""}`}>
            <Link to="../home" className={location === "/home" ? "active" : ""}><span id="home" onClick={linkClick}><FormattedMessage id="homepage"/></span></Link>
            <Link to="../services" className={location === "/services" ? "active" : ""}><span id="services" onClick={linkClick}><FormattedMessage id="services"/></span></Link>
            { location === "/photography" && <Link to="../photography" className="spawn active"><span id="photography" onClick={linkClick}><FormattedMessage id="photography"/></span></Link>}
            { location === "/layout" && <Link to="../layout" className="spawn active"><span id="layout" onClick={linkClick}><FormattedMessage id="layout"/></span></Link>}
            { location === "/animation" && <Link to="../animation" className="spawn active"><span id="animation" onClick={linkClick}><FormattedMessage id="animation"/></span></Link>}
            { location === "/brandidentity" && <Link to="../brandidentity" className="spawn active"><span id="brandidentity" onClick={linkClick}><FormattedMessage id="brandIdentity"/></span></Link>}
            { location === "/packaging" && <Link to="../packaging" className="spawn active"><span id="packaging" onClick={linkClick}>Packaging</span></Link>}
            { location === "/experimentations" && <Link to="../experimentations" className="spawn active"><span id="experimentations" onClick={linkClick}><FormattedMessage id="experimentations"/></span></Link>}
            { location === "/typography" && <Link to="../typography" className="spawn active"><span id="typography" onClick={linkClick}><FormattedMessage id="typography"/></span></Link>}
            <a href="mailto:remy.jeuniaux@icloud.com"><span id="photography">Contact</span></a>
        </div>
    </>
    }